module.exports = __webpack_public_path__ + "static/img/16.acd25dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/16.jpg
// module id = bTF/
// module chunks = 1